import * as Yup from 'yup';
import { BoilerManufacturer, Subject } from '../../models';

export function useValidationSchema() {
  return Yup.object<BoilerManufacturer>().shape({
    // name: Yup.string().nullable().required('Povinné pole'),
    subject: Yup.mixed<Subject>().nullable().required('Povinné pole'),
  });
}
